/* eslint-disable */

/** unique or primary key constraints on table "argo.calendar" */
export enum ArgoCalendarConstraint {
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  CalendarNameUnique = 'calendar_name_unique',
  /** unique or primary key constraint on columns "calendar_id" */
  CalendarPkey = 'calendar_pkey'
}

/** select columns of table "argo.calendar" */
export enum ArgoCalendarSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ScheduleId = 'schedule_id',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_calendar_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.calendar" */
export enum ArgoCalendarSelectColumnArgoCalendarAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  IsDefault = 'is_default'
}

/** select "argo_calendar_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.calendar" */
export enum ArgoCalendarSelectColumnArgoCalendarAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  IsDefault = 'is_default'
}

/** update columns of table "argo.calendar" */
export enum ArgoCalendarUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ScheduleId = 'schedule_id',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

